/**
 * Lab getFraudScore — Flag Final Trust Indicator / Score enrichment.
 */

import { useQuery } from '@tanstack/react-query'
import { cmApi, type FraudScoreRow } from '@/api/cmApi'
import { authHeaders } from '@/auth/session'
import { uniqueUsernames } from '@/features/bet-ticker/fraudScore'

export function useFraudScores(usernames: string[], enabled = true) {
  const ids = uniqueUsernames(usernames)
  return useQuery({
    queryKey: ['cm', 'fraud-scores', ids],
    queryFn: async (): Promise<Map<string, FraudScoreRow>> => {
      const res = await cmApi.fraudScores(authHeaders(), { userIds: ids })
      const map = new Map<string, FraudScoreRow>()
      for (const row of res.scores ?? []) {
        const key = row.username?.trim().toLowerCase()
        if (!key) continue
        map.set(key, row)
      }
      return map
    },
    enabled: enabled && ids.length > 0,
    staleTime: 30_000,
  })
}
